<template>
	<TopNavFooter>
  <div class="main-content" id="admin" style="">
  <spinner :spinnerOn="loading"></spinner>

    <div class="container-fluid" style="background: #fff;padding: 30px;padding-top:35px;">
	
	<span style="font-size:35px; font-weight:bold;">Reports</span>
	<div style="padding-top:20px;">
	<label style="width: 50%;">Enter the group id to generate report:
	<input type="text" v-model="gid" class="form-control" placeholder="Group ID"/>
	</label>
	<button class="btn btn-primary get-logs" v-bind:class="{'disabled': gid.trim().length === 0}" @click="downloadReport()">Download Report</button>
	</div>
	  </div>
    </div>  <!-- END: container -->
</TopNavFooter> </template>
<script>
  import TopNavFooter from "@/components/widgets/TopNavFooter"
  import idmApi from '@/idm-api'
  import Spinner from '@/components/Spinner';
  import { locale } from '@/i18n/locale.js'
  import { EventBus } from '@/event-bus.js';
  import storage from '@/helpers/storage';
  import Blob from 'blob';
  // import Vue from 'vue';
  const apiUrl = process.env.API_URL;
  // const onecargillappid = process.env.KEY_ID;
  const brandDetails = require('../brand-details.json');
  export default {
    name: 'tm',
    components: {
      TopNavFooter,
      Spinner
    },
    created() {
      // this.changeCustomer();
      var self = this;
      self.userId = storage.get('cf-user').sub
      self.email = storage.get('email')
      this.user_lang = this.lang_br
      setTimeout(self.assignUserLang(), 1000) // lang_br for br portuguese
      EventBus.$on('lang', function (language) {
        self.user_lang = self.lang_obj[language]
      })
    },
    mounted () {
      // var self = this
    },
    watch: {
    },
    methods: {
      assignUserLang() {
        var self = this
        self.user_lang = self.lang_obj[this.lang]
      },
      downloadReport() {
        var self = this
        idmApi.downloadReport(`${apiUrl}/auth/report/${self.gid}`).then(function(response) {
          let blob = new Blob([response.data], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;' })
          let link = document.createElement('a')
          link.href = window.URL.createObjectURL(blob)
          link.download = 'Report.xlsx'
          link.click()
        }).catch(error => {
          window.alert(error)
          self.loading = false
        })
      }
    },
    data() {
      return {
        brandDetails: brandDetails,
        lang: locale.lang,
        lang_obj: locale.lang_obj,
        userId: '',
        loading: false,
        user_lang: {},
        prefLang: 'en_US',
        gid: ''
      }
    },
    computed: {
    }
  }
</script>
<style scoped>
button {background:var(--theme-primary) !important}
button { height: 32px !important; color: #fff !important}
.get-logs{
padding: 8px 15px;
    height: 36px !important;
    margin-top: -2px;
	}
th, td{
    padding: 5px 5px !important;
	font-size:14px !important;
}
</style>



// WEBPACK FOOTER //
// Reports.vue?32ddac67